import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=7aa3a180"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports